export const xColored = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.2719 3.81641H20.0831L13.9414 10.836L21.1667 20.388H15.5094L11.0784 14.5948L6.0083 20.388H3.19537L9.76454 12.8798L2.83334 3.81641H8.63427L12.6395 9.11168L17.2719 3.81641ZM16.2853 18.7054H17.843L7.78784 5.41068H6.11623L16.2853 18.7054Z"
      fill="black"
    />
  </svg>
);

export default xColored;
